// extracted by mini-css-extract-plugin
module.exports = {"form":"style-form__form___ZMzUe","radioGroup":"style-form__radio-group___2mW3b"};